module.exports = __webpack_public_path__ + "static/img/morentouxiang.d835c45.png";